import { useEffect, useState } from 'react';

import type { ServerNews } from '../types';

import superagent from 'superagent';

type NewsResponse = {
  body: {
    error: Record<string, string> | null;
    result: ServerNews[] | null;
  };
};

export const useNewsQuery = () => {
  const [data, setData] = useState<ServerNews[]>([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      try {
        const { body }: NewsResponse = await superagent.get('/_mark/texts').query({
          isActive: true,
          product: 'news',
          project: 'solar',
        });

        setData(body?.result ?? []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return {
    data,
    isLoading,
  };
};
